import { useParams } from "@solidjs/router";
import { useQuery } from "@tanstack/solid-query";
import { Show, Suspense } from "solid-js";
import { DetailLayout } from "@/components/layout/DetailLayout";
import { Container, ContainerHeader } from "@/components/shared/Container";
import { Loading } from "@/components/ui/loading";
import { useGetUserApplications } from "@/domains/application/api";
import { MetaTitleWithSeparator } from "@/domains/business/seo";
import { createJobOfferQueryOptions } from "@/domains/job-offer/api";
import {
  DetailContent,
  DetailSheetActions,
} from "@/domains/job-offer/components/detail-sheet";

export const JobOfferRoute = () => {
  // `params.id`, non `const { id } = useParams()`: il proxy di `@solidjs/router`
  // è reattivo solo se letto attraverso di sé, e destrutturarlo congela il
  // parametro al primo valore. Qui la query e il controllo sulle candidature
  // continuerebbero a parlare dell'offerta di partenza dopo una navigazione fra
  // due `/job-offers/:id`.
  const params = useParams();
  const jobOffer = useQuery(() => ({
    // `?? ""` e non un cast: il proxy tipizza il parametro `string | undefined`
    // perché una rotta può essere montata senza, e `enabled` sotto è già la
    // guardia — un id vuoto vale «non chiedere», non «chiedi di niente».
    ...createJobOfferQueryOptions(params.id ?? "", "completed"),
    enabled: !!params.id,
  }));

  const userApplications = useGetUserApplications();

  const isAlreadyApplied = () => {
    if (!userApplications.data?.job_application) return false;
    return userApplications.data.job_application.some(
      (application) => application.job_offer_id === params.id,
    );
  };
  return (
    <DetailLayout>
      <Container class="pb-10">
        <ContainerHeader>
          <MetaTitleWithSeparator>
            {jobOffer.data?.job_offer?.title}
          </MetaTitleWithSeparator>
          <Suspense fallback={<Loading />}>
            <Show when={jobOffer.isSuccess && jobOffer.data?.job_offer}>
              {(job) => (
                <div class="space-y-3 w-full bg-white p-4 rounded-lg">
                  <DetailContent
                    job={job()}
                    isAlreadyApplied={isAlreadyApplied()}
                  />
                  <DetailSheetActions
                    job={job()}
                    isAlreadyApplied={isAlreadyApplied()}
                  />
                </div>
              )}
            </Show>
          </Suspense>
        </ContainerHeader>
      </Container>
    </DetailLayout>
  );
};
